// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#vue-pdf-embed[data-v-93b0c4f2] {\n  overflow-y: scroll;\n  height: 900px;\n}\n.top-header[data-v-93b0c4f2] {\n  font-family: Arial,sans-serif;\n  font-size: 26px;\n  line-height: 29px;\n  color: #00747b;\n  font-weight: bold;\n}\np[data-v-93b0c4f2] {\n  font-family:Arial,sans-serif;\n  font-size:16px;\n  line-height:22px;\n  color:#434343\n}\n.boldText[data-v-93b0c4f2] {\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
